export default [
  {
    id: "approved",
    name: "resources.bookmaker-approvals.status.approved",
  },
  {
    id: "pending",
    name: "resources.bookmaker-approvals.status.pending",
  },
  {
    id: "rejected",
    name: "resources.bookmaker-approvals.status.rejected",
  },
];
